module.exports = __webpack_public_path__ + "img/play-nao-pagos.c67266eb.png";